import { getPublicImageUrl } from '@pflegia/util/functions/s3/get-public-image-url';

import { isImageNotFound } from '@shared/utils/is-image-not-found';

const URL_REGEX = new RegExp(/^https?:/);

/**
 * Returns first working image from `srcSet`.
 *
 * Assumes they are either a full URL, a local image or a key for the public S3 bucket.
 */
export const getTargetImageUrl = async (...srcSet: (string | undefined)[]) => {
  const fallback = '/public/assets/pflegia.png';

  const targetImage = await Promise.all(
    (srcSet.filter(Boolean) as string[]).map(async (url: string) => {
      if (URL_REGEX.test(url) || url.startsWith('/')) {
        const imageError = await isImageNotFound(url);
        return imageError ? undefined : url;
      }

      const s3Image = getPublicImageUrl(url);
      const imageError = await isImageNotFound(s3Image);
      return imageError ? undefined : s3Image;
    }),
  );

  return targetImage.filter(Boolean)[0] ?? fallback;
};
